var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-container", [
    _c(
      "div",
      { staticClass: "d-flex flex-column", style: { gap: "16px" } },
      [
        _c(
          "div",
          {
            staticClass: "d-flex",
            style: { justifyContent: "space-between", alignItems: "center" }
          },
          [
            _c("h1", { staticClass: "text-h5" }, [_vm._v("Downtime Reports")]),
            _c(
              "v-btn",
              {
                attrs: { color: "primary", dark: "" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ name: "DowntimeReports.Create" })
                  }
                }
              },
              [
                _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-plus")]),
                _vm._v(" New Report ")
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "d-flex flex-wrap",
            style: { gap: "10px", alignItems: "center" }
          },
          [
            _c("v-text-field", {
              staticStyle: { "max-width": "200px" },
              attrs: {
                outlined: "",
                dense: "",
                label: "Search",
                "hide-details": "auto",
                "prepend-inner-icon": "mdi-magnify",
                clearable: ""
              },
              on: { input: _vm.fetchReportsDebounced },
              model: {
                value: _vm.search,
                callback: function($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            }),
            _c("v-autocomplete", {
              attrs: {
                outlined: "",
                dense: "",
                "hide-details": "auto",
                label: "Customer",
                name: "customer_id",
                "item-value": "id",
                "item-text": item => `${item.id} - ${item.name}`,
                items: _vm.customers,
                chips: "",
                multiple: ""
              },
              model: {
                value: _vm.customerIds,
                callback: function($$v) {
                  _vm.customerIds = $$v
                },
                expression: "customerIds"
              }
            }),
            _c("v-select", {
              staticStyle: { "max-width": "180px" },
              attrs: {
                items: _vm.statusOptions,
                outlined: "",
                dense: "",
                "hide-details": "auto",
                label: "Status",
                multiple: "",
                clearable: ""
              },
              on: { change: _vm.fetchReportsDebounced },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            }),
            _c("v-autocomplete", {
              staticStyle: { "max-width": "220px" },
              attrs: {
                items: _vm.errorOptions,
                multiple: "",
                outlined: "",
                dense: "",
                "hide-details": "auto",
                chips: "",
                clearable: "",
                label: "Errors"
              },
              on: { change: _vm.fetchReportsDebounced },
              model: {
                value: _vm.errors,
                callback: function($$v) {
                  _vm.errors = $$v
                },
                expression: "errors"
              }
            }),
            _c(
              "v-menu",
              {
                ref: "startMenu",
                attrs: {
                  "close-on-content-click": false,
                  transition: "scale-transition",
                  "offset-y": "",
                  "min-width": "auto"
                },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function({ on, attrs }) {
                      return [
                        _c(
                          "v-text-field",
                          _vm._g(
                            _vm._b(
                              {
                                staticStyle: { "max-width": "150px" },
                                attrs: {
                                  label: "Start Date",
                                  readonly: "",
                                  "hide-details": "auto",
                                  dense: "",
                                  outlined: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.dateStart,
                                  callback: function($$v) {
                                    _vm.dateStart = $$v
                                  },
                                  expression: "dateStart"
                                }
                              },
                              "v-text-field",
                              attrs,
                              false
                            ),
                            on
                          )
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.startMenu,
                  callback: function($$v) {
                    _vm.startMenu = $$v
                  },
                  expression: "startMenu"
                }
              },
              [
                _c("v-date-picker", {
                  on: {
                    input: function($event) {
                      _vm.startMenu = false
                    }
                  },
                  model: {
                    value: _vm.dateStart,
                    callback: function($$v) {
                      _vm.dateStart = $$v
                    },
                    expression: "dateStart"
                  }
                })
              ],
              1
            ),
            _c(
              "v-menu",
              {
                ref: "endMenu",
                attrs: {
                  "close-on-content-click": false,
                  transition: "scale-transition",
                  "offset-y": "",
                  "min-width": "auto"
                },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function({ on, attrs }) {
                      return [
                        _c(
                          "v-text-field",
                          _vm._g(
                            _vm._b(
                              {
                                staticStyle: { "max-width": "150px" },
                                attrs: {
                                  label: "End Date",
                                  readonly: "",
                                  "hide-details": "auto",
                                  dense: "",
                                  outlined: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.dateEnd,
                                  callback: function($$v) {
                                    _vm.dateEnd = $$v
                                  },
                                  expression: "dateEnd"
                                }
                              },
                              "v-text-field",
                              attrs,
                              false
                            ),
                            on
                          )
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.endMenu,
                  callback: function($$v) {
                    _vm.endMenu = $$v
                  },
                  expression: "endMenu"
                }
              },
              [
                _c("v-date-picker", {
                  on: {
                    input: function($event) {
                      _vm.endMenu = false
                    }
                  },
                  model: {
                    value: _vm.dateEnd,
                    callback: function($$v) {
                      _vm.dateEnd = $$v
                    },
                    expression: "dateEnd"
                  }
                })
              ],
              1
            ),
            _c("v-spacer"),
            _c(
              "v-btn",
              {
                attrs: { outlined: "", small: "", color: "primary" },
                on: { click: _vm.fetchReports }
              },
              [
                _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-refresh")]),
                _vm._v(" Refresh ")
              ],
              1
            ),
            _c(
              "v-btn",
              {
                attrs: { outlined: "", small: "", color: "green" },
                on: { click: _vm.printSummary }
              },
              [
                _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-printer")]),
                _vm._v(" Print Summary ")
              ],
              1
            ),
            _c(
              "v-btn",
              {
                attrs: { outlined: "", small: "", color: "teal" },
                on: { click: _vm.downloadCsvSummary }
              },
              [
                _c("v-icon", { attrs: { left: "" } }, [
                  _vm._v("mdi-file-delimited")
                ]),
                _vm._v(" Download CSV ")
              ],
              1
            )
          ],
          1
        ),
        _c("v-data-table", {
          staticClass: "elevation-1",
          attrs: {
            headers: _vm.headers,
            items: _vm.reports,
            loading: _vm.loading,
            page: _vm.page,
            "items-per-page": _vm.limit,
            "server-items-length": _vm.total,
            dense: "",
            outlined: "",
            "disable-sort": ""
          },
          on: {
            "update:page": function($event) {
              _vm.page = $event
            },
            "update:itemsPerPage": function($event) {
              _vm.limit = $event
            },
            "update:items-per-page": function($event) {
              _vm.limit = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "item.form_number",
              fn: function({ item }) {
                return [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.goToEdit(item)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(item.form_number || "N/A") + " ")]
                  )
                ]
              }
            },
            {
              key: "item.customer_id",
              fn: function({ item }) {
                return [
                  _c("span", [
                    _vm._v(
                      _vm._s(item.company || `Customer ${item.customer_id}`)
                    )
                  ])
                ]
              }
            },
            {
              key: "item.machine_type",
              fn: function({ item }) {
                return [_c("span", [_vm._v(_vm._s(item.machine_type || "—"))])]
              }
            },
            {
              key: "item.reported_at",
              fn: function({ value }) {
                return [_c("span", [_vm._v(_vm._s(_vm.formatDate(value)))])]
              }
            },
            {
              key: "item.date_start",
              fn: function({ value }) {
                return [_c("span", [_vm._v(_vm._s(_vm.formatDate(value)))])]
              }
            },
            {
              key: "item.date_end",
              fn: function({ value }) {
                return [_c("span", [_vm._v(_vm._s(_vm.formatDate(value)))])]
              }
            },
            {
              key: "item.purchase_needed",
              fn: function({ item }) {
                return [
                  _c(
                    "v-chip",
                    {
                      attrs: {
                        small: "",
                        color: item.purchase_needed
                          ? "red lighten-2"
                          : "green lighten-2",
                        dark: ""
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(item.purchase_needed ? "Yes" : "No") + " "
                      )
                    ]
                  )
                ]
              }
            },
            {
              key: "item.status",
              fn: function({ item }) {
                return [
                  _c(
                    "v-chip",
                    {
                      staticClass: "text-capitalize",
                      attrs: {
                        small: "",
                        color: _vm.statusColor(item.status),
                        dark: ""
                      }
                    },
                    [_vm._v(" " + _vm._s(item.status || "—") + " ")]
                  )
                ]
              }
            },
            {
              key: "item.actions",
              fn: function({ item }) {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex", style: { gap: "4px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "", color: "purple" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "DowntimeReports.Show",
                                params: { downtimeReportId: item.id }
                              })
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-eye")
                          ])
                        ],
                        1
                      ),
                      !item.locked_at
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.goToEdit(item)
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-pencil")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      !item.locked_at
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "", small: "", color: "red" },
                              on: {
                                click: function($event) {
                                  return _vm.confirmDelete(item)
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-delete")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "", color: "green" },
                          on: {
                            click: function($event) {
                              return _vm.printReport(item.id)
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-file")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        }),
        _c(
          "div",
          { staticClass: "d-flex justify-end align-center" },
          [
            _c("v-pagination", {
              attrs: { length: _vm.pages },
              on: { input: _vm.fetchReports },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }